var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.413 6.587a.584.584 0 10-.826.826l.826-.826zM8 11l-.413.413a.584.584 0 00.826 0L8 11zm4.413-3.587a.584.584 0 10-.826-.826l.826.826zm-8.826 0l4 4 .826-.826-4-4-.826.826zm4.826 4l4-4-.826-.826-4 4 .826.826z",
    fill: "#ADB5BD"
  })));
}

export default SvgChevronDown16;